function ingredientsCarousels() {
  const ingredientCarousels = document.querySelectorAll('.ingredient-carousel-container.splide');
  
  if(!ingredientCarousels) return;
  
  ingredientCarousels.forEach(function(carousel) {

    const splide = new Splide(carousel, {
      type: 'slide',
      pagination: false,
      arrows: true,
      perMove: 1,
      fixedWidth: '50vw',
      arrowPath: 'M37.178 20 2.825 38.99V1.01Z',
      classes: {
        arrows: 'splide__arrows scroll-trigger animate--slide-in'
      },
      breakpoints: {
        768: {
          fixedWidth:'100%'
        },
        1034: {
          fixedWidth: 'calc(100% - 36px)'
        },
        1450: {
          fixedWidth: '723px'
        }
      }
    });

    splide.mount();
  })

}

ingredientsCarousels();